import React, { useState, useEffect } from 'react'
import {
  Paper,
  Grid,
  CircularProgress,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  FormControlLabel,
  Checkbox,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import Cookie from 'js-cookie'
import { useHistory, Link } from 'react-router-dom'
import { DataGrid } from '@material-ui/data-grid'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/AddCircle'
import AddFlatIcon from '@material-ui/icons/Add'
import { useStore } from '../../context/Context'
import useStyles from './styles'
import { deleteGame } from '../../api'
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog'

const GamesDatabase = () => {
  const { isLoading, listGames, setListGames, setMessage } = useStore()
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')
  const history = useHistory()
  const classes = useStyles()
  const theme = useTheme()
  const matchXS = useMediaQuery(theme.breakpoints.down('xs'))
  const [data, setData] = useState([])
  const [yearFilter, setYearFilter] = useState('Not Set')
  const [genreFilter, setGenreFilter] = useState('Not Set')
  const [deleteId, setDeleteId] = useState(null)
  const [singleplayer, setSingleplayer] = useState(false)
  const [multiplayer, setMultiplayer] = useState(false)

  useEffect(() => {
    setData(listGames)
  }, [listGames, setData])

  const handleSearchChange = (e) => {
    const value = e.target.value
    if (value) {
      const dataFound = listGames.filter(game => game.name.toLowerCase().includes(value.toLowerCase()))
      setData(dataFound)
    } else {
      setData(listGames)
    }
    setSearch(value)
  }

  const handleDelete = async (id) => {
    try {
      const token = await Cookie.get('token')
      await deleteGame(id, token)
      const newData = listGames.filter(game => game.id !== id)
      setListGames(newData)
      setMessage(state => ({
        ...state,
        open: true,
        severty: 'success',
        msg: `${id} has just deleted`
      }))
    } catch (error) {
      console.log(error)
      setMessage(state => ({
        ...state,
        open: true,
        severty: 'error',
        msg: error.message,
        link: '/gamesDb'
      }))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const year = yearFilter === 'Not Set' ? '' : yearFilter
    const genre = genreFilter === 'Not Set' ? '' : genreFilter
    const listGamesMockup = listGames.slice()
    const newListGames = listGamesMockup.filter(game => {
      if (year) {
        if ((parseInt(game.release) === year) === false) {
          return false
        }
      }

      if (genre) {
        const gameGenreArray = game.genre.split(',').map(genre => genre.trim())
        if (gameGenreArray.includes(genre) === false) {
          return false
        }
      }

      if (singleplayer) {
        if (game.singlePlayer == false) {
          return false
        }
      }

      if (multiplayer) {
        if (game.multiplayer == false) {
          return false
        }
      }

      return true
    })
    setData(newListGames)
  }

  const range = (start, stop, step = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
  const yearRange = range(1900, new Date().getFullYear() + 1)
  const generateGameGenreList = () => {
    const rawGenres = listGames.map(game => game.genre)
    const genres = rawGenres.join(',').split(',').map(gen => gen.trim())
    const nonDuplicateGenres = genres.reduce((unique, item) => (unique.includes(item) ? unique : [...unique, item]), [])
    return nonDuplicateGenres
  }

  const columns = [
    { field: 'id', headerName: 'No', width: matchXS ? 70 : 80 },
    { field: 'name', headerName: 'Title', width: matchXS ? 120 : 150, renderCell: (cellValues) => <Link className={classes.link} to={`/showGame/${cellValues.id}`}>{cellValues.value}</Link> },
    {
      field: 'release', headerName: 'Release', width: 120, hide: matchXS ? true : false, headerAlign: 'center', renderCell: (cellValues) => (
        <Grid container justifyContent="center">{cellValues.value}</Grid>
      )
    },
    { field: 'genre', headerName: 'Genre', width: 200, hide: matchXS ? true : false },
    { field: 'platform', headerName: 'Platform', width: 120, hide: matchXS ? true : false },
    {
      field: 'singlePlayer', headerName: 'Singleplayer', width: 140, hide: matchXS ? true : false, headerAlign: 'center', renderCell: (cellValues) => (
        <Grid container justifyContent="center">{cellValues.value ? <span style={{ color: theme.palette.success.main }}>Yes</span> : <span style={{ color: theme.palette.error.main }}>No</span>}</Grid>
      )
    },
    {
      field: 'multiplayer', headerName: 'Multiplayer', width: 140, hide: matchXS ? true : false, headerAlign: 'center', renderCell: (cellValues) => (
        <Grid container justifyContent="center">{cellValues.value ? <span style={{ color: theme.palette.success.main }}>Yes</span> : <span style={{ color: theme.palette.error.main }}>No</span>}</Grid>
      )
    },
    {
      field: 'action', headerName: 'Action', width: matchXS ? 100 : 200, headerAlign: 'center', renderCell: (cellValues) => {
        return (
          <Grid container alignItems="center" justifyContent="center">
            <Button variant="contained" disableRipple className={classes.editButton} onClick={() => window.location.href = `/gamesDb/edit/${cellValues.id}`}>
              <EditIcon />
            </Button>
            <Button variant="contained" disableRipple className={classes.deleteButton} onClick={() => {
              setDeleteId(cellValues.id)
              setOpen(true)
            }}>
              <DeleteIcon />
            </Button>
          </Grid>
        )
      }
    }
  ]

  return (
    <main className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        {isLoading ? (
          <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
            <CircularProgress />
          </Grid>
        ) : (
          <>
            <Grid container direction="column" spacing={matchXS ? 1 : 5}>
              <Grid item container justifyContent="space-between">
                {matchXS ? null : (
                  <Grid item container className={classes.filterForm} component="form" onSubmit={handleSubmit} justifyContent="flex-start" spacing={3} alignItems="center">
                    <Grid item>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="release-select-label">Release</InputLabel>
                        <Select
                          labelId="release-select-label"
                          id="release-select"
                          onChange={(e) => setYearFilter(e.target.value)}
                          value={yearFilter}
                          label="Release"
                        >
                          <MenuItem value="Not Set"><span className={classes.notset}>Not Set</span></MenuItem>
                          {yearRange.sort((a, b) => b - a).map(item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="genre-select-label">Genre</InputLabel>
                        <Select
                          labelId="genre-select-label"
                          id="genre-select"
                          onChange={(e) => setGenreFilter(e.target.value)}
                          value={genreFilter}
                          label="Genre"
                        >
                          <MenuItem value="Not Set"><span className={classes.notset}>Not Set</span></MenuItem>
                          {generateGameGenreList().map(item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={<Checkbox checked={singleplayer} className={classes.checkboxInput} onChange={(e) => setSingleplayer(e.target.checked)} />}
                        label="Singleplayer"
                      />
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={<Checkbox checked={multiplayer} className={classes.checkboxInput} onChange={(e) => setMultiplayer(e.target.checked)} />}
                        label="Multiplayer"
                      />
                    </Grid>
                    <Grid item>
                      <Button variant="contained" size="large" type="submit" className={classes.filterButton}>Filter</Button>
                    </Grid>
                    <Grid item>
                      <Button variant="outlined" size="large" type="reset" className={classes.resetButton} onClick={() => {
                        setYearFilter('Not Set')
                        setGenreFilter('Not Set')
                        setSingleplayer(false)
                        setMultiplayer(false)
                        setData(listGames)
                      }}>Reset</Button>
                    </Grid>
                  </Grid>
                )}
                <Grid item>
                  {matchXS ? (
                    <Button
                      variant="contained"
                      onClick={() => history.push('/gamesDb/add')}
                      className={classes.buttonIcon}
                      startIcon={<AddFlatIcon />}
                    >
                      Add
                    </Button>
                  ) : (
                    <IconButton onClick={() => history.push('/gamesDb/add')}>
                      <AddIcon className={classes.addIcon} fontSize="large" />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item>
                  <TextField label="Search by the title ..." value={search} onChange={handleSearchChange} variant="outlined" />
                </Grid>
              </Grid>
            </Grid>
            <div style={{ minHeight: 600, width: '100%' }}>
              <DataGrid
                autoHeight
                disableColumnFilter
                rows={data}
                columns={columns}
                className={classes.dataGrid}
                disableColumnMenu
                disableSelectionOnClick
                disableColumnSelector
                pageSize={6}
                rowsPerPageOptions={[6]}
              />
            </div>
          </>
        )}
      </Paper>
      <ConfirmationDialog open={open} setOpen={setOpen} onOk={() => handleDelete(deleteId)} />
    </main>
  )
}

export default GamesDatabase
